import Route from 'cio/routes/base';
import TransactionalMessageModel from 'cio/models/transactional-message';
import TransactionalMessageSetupSettingsController from 'cio/pods/transactional/message/setup/settings/controller';
import Transition from '@ember/routing/-private/transition';
import isDestroyed from 'cio/utils/is-destroyed';

export default class TransactionalMessageSetupSettings extends Route {
  crumb() {
    return {
      name: 'Configure Settings',
      path: this.routeName,
    };
  }

  resetController(controller: TransactionalMessageSetupSettingsController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      let model = this.modelFor(this.routeName) as TransactionalMessageModel;
      if (!isDestroyed(model)) {
        model.rollbackAttributes();
      }
    }
  }

  setupController(
    controller: TransactionalMessageSetupSettingsController,
    model: TransactionalMessageModel,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);

    controller.set('originalTriggerName', model.triggerName);
    controller.set('triggerNameValidationErrors', []);
  }
}
